(function () {
  'use strict';

  // Maschinenauswahl deaktiviert (siehe stand.md, 25./26.09.2026) — der Header-Chip
  // (data-machine-shortcut) wird in sections/header.liquid nicht mehr gerendert
  // (Schalter machine_filter_active = false). readMachineSelection(),
  // renderMachineShortcut() und der Click-Handler unten laufen dadurch ins Leere:
  // qsa('[data-machine-shortcut]') findet nichts mehr, jedes .forEach() ist dann
  // ein No-Op, kein Fehler. Bewusst nicht entfernt, damit die Funktionen sofort
  // wieder greifen, sobald der Chip in header.liquid reaktiviert wird.
  var MACHINE_KEY = 'emd_machine_selection';

  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function toggleDisclosure(trigger, panel) {
    var expanded = trigger.getAttribute('aria-expanded') === 'true';
    trigger.setAttribute('aria-expanded', String(!expanded));
    panel.hidden = expanded;
    if (!expanded) {
      var focusable = panel.querySelector('input, a, button');
      if (focusable) focusable.focus();
    }
  }

  function initMenuToggle() {
    qsa('.site-header__menu-toggle').forEach(function (btn) {
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;
      btn.addEventListener('click', function () { toggleDisclosure(btn, panel); });
    });
  }

  function initSearchToggle() {
    qsa('.site-header__search-toggle').forEach(function (btn) {
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (!panel) return;
      btn.addEventListener('click', function () { toggleDisclosure(btn, panel); });
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    qsa('[aria-expanded="true"]').forEach(function (btn) {
      var panel = document.getElementById(btn.getAttribute('aria-controls'));
      if (panel) { btn.setAttribute('aria-expanded', 'false'); panel.hidden = true; }
    });
  });

  function readMachineSelection() {
    try {
      var raw = window.localStorage.getItem(MACHINE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function renderMachineShortcut() {
    var selection = readMachineSelection();
    qsa('[data-machine-shortcut]').forEach(function (btn) {
      var label = btn.querySelector('[data-machine-label]');
      if (!label) return;
      if (selection && selection.label) {
        label.textContent = selection.label;
        btn.setAttribute('data-selected', 'true');
      } else {
        label.textContent = label.dataset.emptyText || label.textContent;
        btn.removeAttribute('data-selected');
      }
    });
  }

  qsa('[data-machine-label]').forEach(function (el) {
    el.dataset.emptyText = el.textContent;
  });

  window.addEventListener('storage', function (e) {
    if (e.key === MACHINE_KEY) renderMachineShortcut();
  });
  document.addEventListener('emd:machine:change', renderMachineShortcut);

  qsa('[data-machine-shortcut]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var target = document.getElementById('maschine-waehlen');
      if (target) {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        window.location.href = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
          ? window.Shopify.routes.root + '#maschine-waehlen'
          : '/#maschine-waehlen';
      }
    });
  });

  initMenuToggle();
  initSearchToggle();
  renderMachineShortcut();
})();
